import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import cN from 'classnames';
import Slider from 'react-slick';
import { I_PopularInfo } from '@Redux/search/interfaces';
import { RootState } from '@Redux/search/store';
import ArrowLeft3 from '@lion-design/icons';
import ArrowRight3 from '@lion-design/icons';
import Card from './subComponent/Card';
import styles from './styles.module.scss';
import { useMediaQuery } from 'react-responsive';

interface IRecommendProps {
    Recommend: I_PopularInfo[];
}

const Recommends: React.FC<IRecommendProps> = (props) => {
    const moduleName = 'recommends';
    const Recommend = props.Recommend;

    // 按鈕功能為"切換各團顯示(列表)"時，顯示結果為卡片
    const isPC = useMediaQuery({ query: '(min-width: 980px)' });
    const [isShow, setIsShow] = useState(false);
    // let isShow = Recommends.length > 0;
    useEffect(() => {
        setIsShow(Recommend.length > 0);
    }, [Recommend]);

    function NextArrow(props: any) {
        const { className, style, onClick } = props;
        return (
            <div
                className={cN(styles.sliderBtn, styles.sliderBtn_next)}
                // style={{ ...style }}
                onClick={onClick}
            >
                <ArrowRight3 type="arrow-right-3" />
            </div>
        );
    }
    function PrevArrow(props: any) {
        const { className, style, onClick } = props;
        return (
            <div
                className={cN(styles.sliderBtn, styles.sliderBtn_prev)}
                // style={{ ...style }}
                onClick={onClick}
            >
                <ArrowLeft3 type="arrow-left-3" />
            </div>
        );
    }

    const settings = useMemo(
        () => ({
            dots: false,
            infinite: Recommend.length >= 2,
            speed: 500,
            autoplay: true,
            autoplaySpeed: 6000,
            cssEase: 'ease-in',
            swipeToSlide: true,
            slidesToShow: Recommend.length <= 2 ? Recommend.length : 3,
            slidesToScroll: 1,
            className: styles.Cards,
            variableWidth: true,
            nextArrow: isPC ? <NextArrow /> : undefined,
            prevArrow: isPC ? <PrevArrow /> : undefined,
        }),
        [Recommend]
    );

    const onErrImg = (() => {
        if (process.env.ENV === 'prod') {
            return 'https://www.liontravel.com/cto/view/default16-9.jpg';
        }

        if (process.env.ENV === 'rel') {
            return 'https://uwww.liontravel.com/cto/view/default16-9.jpg';
        }

        return '/uliontravel/cto/view/default16-9.jpg';
    })();

    return isShow ? (
        <div className={cN(moduleName, styles[`${moduleName}`])}>
            <div className={styles.Title}>精選人氣推薦</div>
            <Slider {...settings}>
                {Recommend?.map((item: I_PopularInfo, i: number) => {
                    const cardProps = {
                        imgSrcPC: item.ImageURL,
                        imgSrcM: item.ImageURL,
                        onErrImg,
                        imgAlt: item.ProductName,
                        imgTitle: item.ProductName,
                        productInfo: item.ProductName,
                        productLink: item.ProductURL,
                        price: item.ProductPrice,
                        ProductType: item.ProductType,
                    };
                    return <Card key={i} {...cardProps} />;
                })}
            </Slider>
        </div>
    ) : null;
};

export default Recommends;
